<template>
  <div style="min-height: 730px;">
    <!-- 버튼 area -->
    <div class="btn-stat">
      <button type="button" class="default btn" @click="infoPopup($refs.infoPopup, $event)">기본정보</button>
      <button type="button" class="default btn mobile-hidden" @click="pivotReverse()">행열전환</button>
      <button type="button" class="default btn mobile-hidden" @click="filterBox('pivot')">피벗</button>
      <button type="button" class="default btn mobile-hidden" @click="filterBox('filter')">조회설정</button>
      <button type="button" class="default btn mobile-hidden bg-sky" @click="copySheetData()">화면복사</button>
      <button type="button" class="default btn mobile-hidden bg-sky " @click="$refs.downLoadPopup.open($event)">다운로드</button>
      <button type="button" class="default btn mobile-hidden bg-sky" @click="$refs.apiPopup.open($event)">Open API</button>
      <button type="button" style="width: auto;padding: 0 10px;" class="default btn mobile-hidden bg-sky" @click="onClickMyStatsPopup($event)">링크 주소(URL) 생성</button>
      <button type="button" class="default btn bg-sky" v-show="infoItem.cmmtDesc !== null" @click="$refs.comDescPopup.open($event)">주석</button>
      <a href="/portal/statsManual" target="_blank" title="새창으로 열림" class="default btn mobile-hidden bg-sky">도움말</a>
    </div>
    <div class="ibsheet-box">
      <div class="sheet-top">
        <div class="left-tab">
          <ul class="sheet-tab-menu">
            <li><a href="#n" class="tab1">통계표</a></li>
<!--            <li><a href="#n" class="tab2" title="새창으로 열림" @click="chartPopup()">차트(새창)</a></li>-->
            <li><a href="#n" class="tab2" title="새창으로 열림" @click="chartFilterPopup()">차트(새창)</a></li>
          </ul>
          <div class="mobile-hidden">
            <ul v-bind:ref="'tempSelector' + this.itemIdx" class="btn-temp-color">
              <li><button type="button" v-bind:disabled="ColBgColor === 'temp-bg-blue'" class="btn-temp-blue" data-temp-bg="temp-bg-blue" @click="tempBgColor($event)" title="색상: 블루, 글자 크기: 13px"><span class="hidden">템플릿 블루</span></button></li>
              <li><button type="button" v-bind:disabled="ColBgColor === 'temp-bg-orange'" class="btn-temp-orange" data-temp-bg="temp-bg-orange" @click="tempBgColor($event)" title="색상: 오렌지, 글자 크기: 12px"><span class="hidden">템플릿 오렌지</span></button></li>
              <li><button type="button" v-bind:disabled="ColBgColor === 'temp-bg-green'" class="btn-temp-green" data-temp-bg="temp-bg-green" @click="tempBgColor($event)" title="색상: 그린, 글자 크기: 11px"><span class="hidden">템플릿 그린</span></button></li>
              <li><div style="line-height: 28px; font-size: 13px; margin-left: 10px; ">* 데이터 또는 데이터 영역 선택 시 통계표 하단에 차트가 나타납니다(메뉴얼 참조)</div></li>
            </ul>
          </div>
        </div>
        <p v-show="infoItem.msrUnitNm"> 단위 : {{ infoItem.msrUnitNm }}</p>
      </div>
      <!-- 조회설정(필터) 레이어 -->
      <div v-bind:ref="'filterSlide' + this.itemIdx" class="filter-slide-box">
        <ul class="sheet-tab-menu filter-layer">
          <li class="mobile-hidden"><span :class="[filterTab === 'pivot'?'tab1':'tab2']" ref="btnPivot" @click="selectTabPannel('pivot', $event)">피벗</span></li>
          <li><span :class="[filterTab === 'filter'?'tab1':'tab2']" ref="btnFilter" @click="selectTabPannel('filter', $event)">조회설정(필터)</span></li>
        </ul>
        <button type="button" class="btn-filter-close" @click="filterBoxClose()"><span class="hidden">닫기</span>
        </button>

        <!-- 피벗 -->
        <div v-show="filterTab === 'pivot'" class="pannel" ref="pivot" style="display: none;">
          <pivotPopup ref="pivotPopup" @pivot-apply="pivotApply" :pivot-option="pivotOption" :array-header="arrayHeader"  data-vue-ref="pivotPopup"></pivotPopup>
        </div>
        <!-- // 피벗 -->

        <!-- 조회설정(필터) -->
        <div v-show="filterTab === 'filter'" ref="filterSetting" class="pannel" style="display: none; height: calc(100% - 37px);">
          <div class="filter-list-inner">
            <div class="filter-list-box" style="height: 30px;">
              <!-- 검색 영역 -->
              <div class="filter-search">
                <input type="search" v-model="filterSearchText" v-on:keyup.enter="filterSearch" placeholder="필터 검색" title="필터 검색">
                <div v-show="filterSearchTotalCount > 0" style="display: flex;">
                  <span style="font-size: 12px; margin: 0 8px;"> {{filterSearchCurrent}}/{{filterSearchTotalCount}}</span>
                  <button type="button" @click="moveSearchIndex('up')" class="filter-search-up"></button>
                  <button type="button" @click="moveSearchIndex('down')" class="filter-search-down"></button>
                  <button type="button" @click="moveSearchIndex('delete')" class="filter-search-close"></button>
                </div>
              </div>
            </div>
            <div class="filter-list-box">
              <div class="filter-tit">
                <h5>시점 (연도)</h5>
                <button class="filterListToggle" type="button" @click="filterListToggle($event)"><span class="hidden">버튼</span></button>
              </div>
              <div class="check-list-box">
                <ul>
                  <li>
                    <span class="inp-box">
                      <label>
                        <input type="checkbox" ref="checkAllYear" v-model="filterChecker.year.checked" checked data-all-check="all" @change="filterAllCheck($refs.yearTreeChecker, $event)">
                        <span class="filter-list-Label">전체 선택</span>
                      </label>
                    </span>
                  </li>
                  <!-- 시점 반복 START-->
                  <TreeChecker ref="yearTreeChecker" v-for="(data, i) in arrayYearItemFilterData"
                               @checked-update="allCheckFromChild(arrayYearItemFilterData, $refs.checkAllYear, filterChecker.year)"
                               :item="data" :index="i.toString()" :code="'col'" v-bind:key="i">
                  </TreeChecker>
                  <!-- 시점 반복 END-->
                </ul>
              </div>
            </div>
            <div class="filter-list-box">
              <div class="filter-tit">
                <h5>항목 ({{ colFilterDisplay.join(',') }})</h5>
                <button class="filterListToggle" type="button" @click="filterListToggle($event)"><span class="hidden">버튼</span></button>
              </div>
              <div class="check-list-box">
                <ul>
                  <li>
                    <span class="inp-box">
                      <label>
                        <input type="checkbox" ref="checkAllCol" v-model="filterChecker.col.checked" data-all-check="all" checked @change="filterAllCheck($refs.colTreeChecker, $event)">
                        <span class="filter-list-Label">전체 선택</span>
                      </label>
                    </span>
                  </li>
                  <!-- 표두 반복 START-->
                  <TreeChecker ref="colTreeChecker" v-for="(data, i) in arrayColItemFilterData"
                               @checked-update="allCheckFromChild(arrayColItemFilterData, $refs.checkAllCol, filterChecker.col)"
                               :item="data" :index="i.toString()" :code="'col'" v-bind:key="i">
                  </TreeChecker>
                  <!-- 표두 반복 END-->
                </ul>
              </div>
            </div>
            <div class="filter-list-box">
              <div class="filter-tit">
                <h5>통계분류 ({{ rowFilterDisplay.join(',') }})</h5>
                <button class="filterListToggle" type="button" @click="filterListToggle($event)"><span class="hidden">버튼</span></button>
              </div>
              <div class="check-list-box">
                <ul>
                  <li>
                      <span class="inp-box">
                        <label>
                          <input type="checkbox" ref="checkAllRow" v-model="filterChecker.row.checked" data-all-check="all" checked @change="filterAllCheck($refs.rowTreeChecker, $event)">
                          <span class="filter-list-Label">전체 선택</span>
                        </label>
                      </span>
                  </li>
                  <!-- 표측 반복 START-->
                  <TreeChecker ref="rowTreeChecker" v-for="(data, i) in arrayRowItemFilterData"
                               @checked-update="allCheckFromChild(arrayRowItemFilterData, $refs.checkAllRow, filterChecker.row)"
                               :item="data" :index="i.toString()" :code="'row'" v-bind:key="i">
                  </TreeChecker>
                  <!-- 표측 반복 END-->
                </ul>
              </div>
            </div>
            <div class="pop-btn-box align-c">
              <button type="button" class="pop-btn w-fix bg-blue" @click="filterApply()">적용</button>
              <button type="button" class="pop-btn w-fix line-white" @click="filterReset()">초기화</button>
            </div>
          </div>
        </div>
        <!-- // 조회설정(필터) -->
      </div>
      <div class="ibs-box">

        <!-- // 조회설정(필터) 레이어 -->
        <div class="sheet-box">
          <div v-bind:id="'sheetDiv' + this.itemIdx" class="sheet-div" style="height: 730px; /*display: none;*/">
          </div>
        </div>
      </div>
    </div>

    <div class="stat-section" v-show="this.showChart">
      <div class="stat-title">
        <h4>선택된 영역의 차트</h4>
        <button class="img-save" type="button" style="width: 120px" @click="saveChartToImg()">이미지 저장</button>
      </div>
      <div v-bind:id="'chartDiv' + this.itemIdx" class="chart-div" style="height: 500px; /*display: none;*/"></div>
    </div>

    <!-- 기본정보 팝업 -->
    <div class="layer-popup-wrap" ref="infoPopup">
      <div class="layer-popup" tabindex="0">
        <h4 class="pop-tit">기본정보</h4>
        <div class="pop-cont">
          <table class="pop-table">
            <caption>기본정보</caption>
            <colgroup>
              <col class="res-col">
              <col>
            </colgroup>
            <tbody>
            <tr>
              <th>통계표명</th>
              <td>{{ staticBasicData.tblKorNm }}</td>
            </tr>
            <tr>
              <th>목록</th>
              <td>{{ staticBasicData.pathNm }}</td>
            </tr>
            <tr>
              <th>조사명</th>
              <td>{{ staticBasicData.statKorNm }}</td>
            </tr>
            <tr>
              <th>입력연도</th>
              <td>{{ staticBasicData.tblYearMonth }}</td>
            </tr>
            <tr>
              <th>URL</th>
              <td>
                <div class="copy-url">
                  <div class="txt-ell">{{ staticBasicData.copyUrl }}</div>
                  <button type="button" @click="copySheetUrl" class="btn-fnc">URL 복사</button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <button type="button" class="btn-pop-close" @click="popupClose($refs.infoPopup)"><span class="hidden">닫기</span>
        </button>
      </div>
    </div>
    <!-- // 기본정보 팝업 -->

    <!-- 다운로드 팝업 -->
    <DownLoadPopup ref="downLoadPopup" :stat-id="statId" @exportSheetData="exportSheetData" data-vue-ref="downLoadPopup"></DownLoadPopup>
    <!-- // 다운로드 팝업 -->

    <!-- 주석 팝업 -->
    <comDescPopup ref="comDescPopup" :cmmt-desc="infoItem.cmmtDesc"  data-vue-ref="comDescPopup"></comDescPopup>
    <!-- // 주석 팝업 -->

    <!-- 피벗 팝업 -->
    <!-- <pivotPopup ref="pivotPopup" @pivot-apply="pivotApply" :pivot-option="pivotOption" :array-header="arrayHeader"  data-vue-ref="pivotPopup"></pivotPopup> -->
    <!-- // 피벗 팝업 -->

    <!-- 오픈API 팝업 -->
    <OpenApiPopup ref="apiPopup" :stat-id="statId" type="subject" data-vue-ref="apiPopup"></OpenApiPopup>
    <!-- // 오픈API 팝업 -->

    <!-- 나의 통계표 팝업 -->
    <MyStatsPopup ref="statPopup" :stats-id="statId" :stats-name="stblTitle" data-vue-ref="statPopup"></MyStatsPopup>
    <!-- // 나의 통계표 팝업 -->
  </div>
</template>
<script>
import $ from 'jquery'
import * as api from "../api/StblData";
import TreeChecker from "../components/tree/TreeChecker";
import OpenApiPopup from "../components/popup/OpenApiPopup";
import DownLoadPopup from "../components/popup/DownLoadPopup";
import comDescPopup from "../components/popup/comDescPopup";
import pivotPopup from "../components/popup/pivotPopup";
import MyStatsPopup from "../components/popup/MyStatsPopup";
import {getStatsParameters} from "../api/my-stats";

export default {
  name: "StblView",
  components: {MyStatsPopup, OpenApiPopup, TreeChecker, DownLoadPopup, comDescPopup, pivotPopup},
  props: {
    subItemId: {
      type: String,
      default: ''
    },
    statId: {
      type: String,
      default: ''
    },
    itemIdx: {
      type: String,
      default: ''
    },
    statsParametersId: {
      type: String,
      default: ''
    },
    infoItem: {}
  },
  data() {
    return {
      stblTitle: ''   // 통계표 명
      , staticBasicData: {} // 기본정보
      , arrayData: []   // 통계 기초 데이터
      , arrayHeader: [] // 헤더 데이터
      , arrayDataFilter: [] // 통계 필터된 데이터
      , arrayChartData: [] // 차트전달용 초기 데이터
      , tblMgmNo: ''    // 통계 테이블 번호
      , colPivotTitle: ''  // 필터 타이틀
      , rowPivotTitle: ''  // 필터 타이틀
      , colFilterTitle: ''
      , rowFilterTitle: ''
      , colFilterDisplay: []
      , rowFilterDisplay: []
      , arrayColItemData: []
      , arrayRowItemData: []
      , arrayYearItemFilterData: []
      , arrayColItemTitleData: []
      , arrayColItemFilterData: []  // 구조화된 표두 데이터
      , arrayRowItemTitleData: []
      , arrayRowItemFilterData: [] // 구조화된 표측 데이터
      , options: {}     // ibSheet 옵션
      , pivotOption: {}   // pivot 옵션
      , chartOptions: {}  // ibChart 옵션
      , stblSheet: {}   // sheet 객체
      , stblSheetDiv: {}    // sheetDiv
      , stblSheetId: "sheetDiv" + this.itemIdx   // sheet 객체 ID
      , selectRowData: ''   // 차트 생성 데이터 (시트 선택 Row 데이터)
      , stblChart: {}   // 차트 객체
      , stblChartId: "chartDiv" + this.itemIdx  // 차트 객체 ID
      , showChart: false  // 차트 표시여부
      , delimiterCha: '▷'   // 데이터처리 구분자
      , yearKey: '년도'
      , statsHstryList: [] //공표후 통계표 수정/보완 내역,
      , beforeCrossColorInfo: {}
      , filterTab : 'filter'
      , filterSearchText: ''
      , filterSearchList: []
      , filterSearchTotalCount: 0
      , filterSearchCurrent : 1
      , ColBgColor : 'temp-bg-blue'
      , scrollCount : 20
      , popBtn : ''
      , filterChecker: {
        year : {checked : true},
        col : {checked : true},
        row : {checked : true}
      }
    }
  },
  created() {
    // 아웃사이드 클릭 팝업 종료
    const that = this;
    this.outsideClickHandler = (e) => {
      if (e.target.classList.contains('layer-popup-wrap')) {
        const vueReference = e.target.getAttribute('data-vue-ref');
        if (vueReference)
          if (that.$refs[vueReference]) {
            that.$refs[vueReference].close();
          }
          else
            this.popupClose(e.target)
      }
    };
    document.addEventListener('click', this.outsideClickHandler);
  },
  mounted() {
    // 화면 로딩바 실행
    this.$emit('spinner-apply', true);
    this.selectStblInfo();
  },
  beforeDestroy() {
    this.$emit('spinner-apply', false);
    this.disposeIbSheet();
    document.removeEventListener('click', this.outsideClickHandler);
  },
  methods: {

    /**
     * 통계표 데이터 조회
     */
    selectStblInfo() {
      const paramData = {
        tblMgmNo: this.statId,
      }
      this.selectPivotStblInfo(paramData);
    },
    async selectPivotStblInfo(paramData) {
      const resultData = await api.selectPivotStblInfo(paramData)
      this.setData(resultData);
    },
    /**
     * 통계표 데이터 셋팅
     * @param paramData
     */
    setData(paramData) {

      // 년도 필터 데이터 생성
      const setFilterYearData = (arrData, arrFilterData, checked) => {
        arrData.forEach(year => {
          let obj = {filterKey: this.yearKey, itemName: year, checked: checked}
          arrFilterData.push(obj);
        });
      };

      // 표두, 표측 필터 데이터 생성
      const setFilterData = (arrData, arrFilterData, arrTitleData, checked) => {
        const dataInfoMap = {};
        // 데이터 맵 생성 및 초기설정 처리
        arrData.forEach(item => {
          if (item.itemLevel !== 0) { // root 제외
            item.child = [];
            item.filterKey = arrTitleData[item.itemLevel - 1].levelTitle
            this.$set(item, 'checked', checked);
            dataInfoMap[item.itemNo] = item;
          }
        });
        // array 데이터 생성
        arrData.forEach(item => {
          if (item.itemLevel === 0) { // root
          } else {
            if (item.itemLevel === 1) {  // 1레벨부터 적재
              arrFilterData.push(item);
            } else {
              const parent = dataInfoMap[item.upItemNo]
              if (parent) {
                parent.child.push(item);
              }
            }
          }
        });
      };

      // 기초 데이터 셋팅
      this.stblTitle = paramData.stblTitle;
      this.arrayHeader = paramData.headerList;
      this.arrayData = paramData.dataList.data;
      this.arrayDataFilter = this.arrayData;
      this.arrayColItemData = paramData.colItemList;
      this.arrayRowItemData = paramData.rowItemList;
      this.arrayColItemTitleData = paramData.colItemTitleList;
      this.arrayRowItemTitleData = paramData.rowItemTitleList;
      this.colFilterTitle = this.arrayColItemTitleData.map(ele => ele.levelTitle).join(",");
      this.rowFilterTitle = this.arrayRowItemTitleData.map(ele => ele.levelTitle).join(",");
      this.colPivotTitle = this.yearKey.concat(",", this.colFilterTitle);
      this.rowPivotTitle = this.rowFilterTitle;

      // 피벗 옵션 셋팅
      this.pivotOption = {
        row: this.rowPivotTitle.split(','),
        col: this.colPivotTitle.split(','),
        data: 'VALUE'
      };
      // 차트 옵션 셋팅
      this.chartSetOption = {
        categoriesKey: this.yearKey,
        stackKey: this.colFilterTitle.split(','),
        seriesKey: this.rowPivotTitle.split(','),
        valueKey: 'VALUE'
      };
      // 조회설정(필터) 타이틀 셋팅
      this.colFilterDisplay = this.arrayHeader.filter(item => item.titleCd.indexOf('COL') > -1).map(item => item.levelTitle);
      this.rowFilterDisplay = this.arrayHeader.filter(item => item.titleCd.indexOf('ROW') > -1).map(item => item.levelTitle);

      // 차트용 데이터 셋팅
      this.arrayChartData = this.arrayData;

      // 필터 데이터 처리
      let yearArray = [...new Set(this.arrayDataFilter.map(item => item[this.yearKey]))];
      setFilterYearData(yearArray, this.arrayYearItemFilterData, true);
      setFilterData(this.arrayColItemData, this.arrayColItemFilterData, this.arrayColItemTitleData, true);
      setFilterData(this.arrayRowItemData, this.arrayRowItemFilterData, this.arrayRowItemTitleData, true);

      // 공표후 통계표 수정/보완 내역 조회 및 화면 처리
      this.statsHstryList = paramData.statsHstryList;

      // 나의 통계표 접속 분기 처리
      if (this.statsParametersId) {
        //INFO: 나의 통계표
        this.setMyStatsParameters(this.statsParametersId);
      } else {
        this.initSheet(this.pivotOption, this.arrayDataFilter);
      }
    },

    /**
     * 시트 사이즈 변경
     * @param sheet
     * @param dataRowCnt
     * @param baseRowCnt
     */
    resizeSheet(sheet,dataRowCnt, baseRowCnt){
      let p = sheet.MainTag.parentNode;  //시트 부모 객체
      let h = sheet.MainTag.clientHeight; //시트객체 높치

      //시트에서 데이터 영역을 제외한 나머지 영역에 대한 높이
      let hOtherRows = h - sheet.MainTable.tBodies[0].querySelector('.IBBodyMid').clientHeight - sheet.MainTable.tBodies[0].querySelector(".HeightSpace").parentNode.offsetHeight;
      //기준행과 조회된 데이터행 수에 따라 부모의 크기를 바꾼다.

      if(dataRowCnt < baseRowCnt){
        p.style.height = ((dataRowCnt * sheet.RowHeight) + hOtherRows)+"px";
      } else {
        sheet.MainTag.style.height = "730px";
        p.style.height = "730px";
      }
    },

    /**
     * 통계표 -> 시트 초기화 및 생성
     * @param pivotOption
     * @param data
     */
    initSheet(pivotOption, data) {

      // 시트 초기화 시 로딩바 실행 (종료 -> 랜더링 완료 시)
      this.$emit('spinner-apply', true);

      // 데이터 피벗 처리
      let returnData = this.pivotData(pivotOption, data, true);

      // 시트 COL 정보 설정
      this.options.Cols = returnData.headers;
      this.options.LeftCols = returnData.leftCols;

      // 시트 공통 설정
      this.options.Cfg = {
        //CanSort: 1,
        //SortIcons: 2,
        CanEdit: 4,  // 시트 편집 false
        InfoRowConfig: {Layout: [{Value: "<div style='float: left'>" + this.stblTitle + "</div>"/*, TextColor:"#FF0000"*/}, "Count"]},
        //SearchMode: 2,
        HeaderMerge: 6,  // 헤더행기준 자동 병합 처리
        DataMerge: 1,
        PrevColumnMerge: 1,
        PrevColumnMergeMode: 1,
        IgnoreFocused: true,  // 조회후 포커스를 제외
        SelFocusColor: 1,
        FitWidth: true,
        ScrollOverSheet: true,
        CanColMove:2,
        NoVScroll:1
      }

      if (returnData.data.length > this.scrollCount) {
        this.options.Cfg.NoVScroll = 0;
      }

      // 이벤트 처리
      this.options.Events = {
        onSearchFinish: (evtParam) => {
        },
        onRenderFinish: function () {
        },
        onRenderFirstFinish: (evtParam) => {
          // 시트 사이즈 변경 처리
          this.resizeSheet( evtParam.sheet, evtParam.sheet.getDataRows().length, this.scrollCount);

          // 차트 테이블 테마 class 추가
          this.tempTextSize(this.ColBgColor);

          // 로딩바 제거
          this.$emit('spinner-apply', false);
        },
        onSelectEnd: (evtParam) => {
          // 셀 영역 선택
          // 차트 생성
          this.selectToChart(evtParam);
        },
        onClick: (evtParam) => {
          // 헤더를 클릭 했을경우 처리
          if (evtParam.row.Kind === 'Header') {
            return;
          }
          // 색상변경 처리
          this.setCrossColor(evtParam);

          // 차트 생성
          this.clickToChart(evtParam);
        },
        onExportFinish: (evtParam) => { // 파일다운로드
        }
      }
      // IbSheet 객체 제거
      this.disposeIbSheet();

      // IBSheet 생성시 dom 존재 여부 체크
      this.stblSheetDiv = document.querySelector('#' + this.stblSheetId);
      if (!this.stblSheetDiv) {
        this.$emit('spinner-apply', false);
        return;
      }

      // IbSheet 생성
      this.stblSheet = IBSheet.create({
        id: this.stblSheetId,     // 시트 객체 ID
        el: this.stblSheetId,     // 시트를 생성할 DIV객체 ID
        options: this.options,       // 초기화 구문 변수
        data: returnData.data   // 초기 로딩 데이터
      });
      this.stblSheet.vueComponent = this;
      this.selectRowData = '';

      // 차트 제거
      this.disposeIbchart();
      this.showChart = false;

      // 차트 초기화
      this.initChart();
    },
    /**
     * 통계표 -> 차트 초기화
     */
    initChart() {
      this.chartOptions.initChartData = {
        chart: {type: 'column'},
        colors: ["#fd9c3c", "#e5404c", "#f6c8ba", "#b7b0b5", "#2ea4a8", "#47586f", "#adab6e", "#c9a9c3"],
        plotOptions: {
          series: {
            shadow: false,
            marker: {
              enabled: true, states: {hover: {enabled: true},select: {enabled: true}}
            }
          }
        },
        legend: {enabled: true},
        yAxis: {title: {text: this.stblTitle}},
        events : {
          searchEnd: () => {
            this.showChart = true;
          }
        }
      };

      createIBChart(this.stblChartId, this.stblChartId, {
        width: "100%",
        height: "100%"
      });

      this.stblChart = window[this.stblChartId];
      this.stblChart.setOptions(this.chartOptions.initChartData);
    },
    /**
     * 시트 클릭 이벤트 처리 => 차트 생성
     * @param evtParam
     */
    clickToChart(evtParam) {
      let seriesNames = [];
      let seriesName = "";
      this.options.LeftCols.map(item => item.Name).forEach(col => {
        seriesNames.push(evtParam.sheet.getValue(evtParam.row, col));
      });
      seriesName = seriesNames.join();
      let pparam = {
        datadirection: "horizontal",
        datarowcol: [evtParam.row],
        legendseriesname: [seriesName],
        legendtitle: "", // 범례
        startdatarowcol: this.options.Cols[0].Name,
        enddatarowcol: this.options.Cols[this.options.Cols.length -1].Name,
        labelrowcol: evtParam.sheet.getHeaderRows()[evtParam.sheet.getHeaderRows().length -1],
        labelrowheader: evtParam.sheet.getHeaderRows(),
        startlabelrowcol: this.options.Cols[0].Name,
        endlabelrowcol: this.options.Cols[this.options.Cols.length -1].Name,
        labeldirection: "horizontal",
        seriestype: ["column"]
      };
      // 차트 생성
      SHEET2CHART(this.stblSheet, this.stblChart, pparam);
    },
    /**
     * 시트 셀 셀렉트 이벤트 처리 => 차트 생성
     * @param evtParam
     */
    selectToChart(evtParam) {
      let rowsArr = evtParam.rows;
      let colsArr = evtParam.cols;
      let seriesTypeArr = [];
      let legendSeriesNameArr = [];
      let i, max;

      if (evtParam.range === undefined || evtParam.range.length === 0) {
        console.warn("evtParam.range is null");
        return;
      }

      if (colsArr === undefined || colsArr.length === 0) {
        console.warn("colsArr is null");
      }

      for (i = 0, max = rowsArr.length; i < max; i++) {
        seriesTypeArr.push("column");
        let seriesNames = [];
        this.options.LeftCols.map(item => item.Name).forEach(col => {
          seriesNames.push(evtParam.sheet.getValue(rowsArr[i], col));
        })
        legendSeriesNameArr.push(seriesNames.join());
      }

      let pparam = {
        datadirection: "horizontal",
        datarowcol: rowsArr,
        legendseriesname: legendSeriesNameArr,
        startdatarowcol: evtParam.range[0][1],
        enddatarowcol: evtParam.range[0][3],
        labelrowcol: evtParam.sheet.getHeaderRows()[evtParam.sheet.getHeaderRows().length -1],
        labelrowheader: evtParam.sheet.getHeaderRows(),
        startlabelrowcol: evtParam.range[0][1],
        endlabelrowcol: evtParam.range[0][3],
        labeldirection: "horizontal",
        seriestype: seriesTypeArr
      };
      // 차트 생성
      SHEET2CHART(this.stblSheet, this.stblChart, pparam);
    },

    /**
     * 조회한 원본데이터를 피벗데이터로 변환 처리
     * @param pivotOption
     * @param data
     * @param leftCol
     * @returns {{headers: *[], data: *[], rowMap: {}, leftCols: *[]}}
     */
    pivotData(pivotOption, data, leftCol) {
      const items = [];
      const itemMap = {};
      const rowMap = {};
      const headers = [];
      const headerMap = {};
      const leftCols = [];

      // 피벗 기준 데이터 정렬 처리
      let sortArray =[];
      sortArray.push({field: this.yearKey, direction: 'desc'});
      this.pivotOption.row.forEach(item => {
        if (this.yearKey !== item) {
          sortArray.push({field: item + '_SORT', direction: 'asc'});
        }
        else {
          sortArray.push({field: item, direction: 'desc'});
        }
      })
      data = this.sortByFields(data, sortArray);

      const colKeyFunc = item => {
        return colHeaderFunc(item).join(this.delimiterCha);
      }

      const rowKeyFunc = item => {
        return pivotOption.row.map(row => {
          return item[row]
        }).join(this.delimiterCha);
      }

      const colHeaderFunc = item => {
        return pivotOption.col.map(col => {
          return item[col];
        });
      }

      const createHeaderFunc = (rowArray, name, option) => {
        let colHeader = {"Header": "", "Type": "Text", "Width": 120, "Name": "", "Align": "Right" }
        let headers = []
        rowArray.forEach((header, index) => {
          if (this.arrayHeader.find(item => item.titleCd === header)) {
            // 항목 값이 정상적으로 입력 되어있을경우 항목값으로 보여주고 없을경우 COL1 행태로 표출 (이슈 1)
            headers.push(this.arrayHeader.find(item => item.titleCd === header).levelTitle)
          } else {
            // 헤더열이 공백이거나 ' ' 일경우 이전 헤더의 값을 셋팅(헤더 병합 처리)
            if (header == null || header.toString().trim() === '') {
              headers.push(headers[index -1])
            } else {
              headers.push(header)
            }
          }
        })
        if (option !== undefined) {
          Object.assign(colHeader, option)
        }
        return Object.assign(colHeader, {
          Header: headers,
          Name: name.replace(/\s/g, "")
        })
      }

      //INFO 헤더 구분 설정
      pivotOption.row.forEach(rowItem => {
        const rowArray = new Array(pivotOption.col.length).fill('');
        rowArray[0] = rowItem;
        //headers.push(createHeaderFunc(rowArray, rowItem));
        if (leftCol) {
          leftCols.push(createHeaderFunc(rowArray, rowItem, {"Align": "Center"}))
        } else {
          headers.push(createHeaderFunc(rowArray, rowItem));
        }
      });

      data.forEach(item => {
        let colKey = colKeyFunc(item).replace(/\s/g, "");
        const rowKey = rowKeyFunc(item).replace(/\s/g, "");
        const key = colKey + this.delimiterCha + rowKey;

        if (!rowMap.hasOwnProperty(rowKey)) {
          const newItem = {}
          pivotOption.row.forEach(rowName => {
            newItem[rowName] = item[rowName];
          });

          rowMap[rowKey] = newItem;
          items.push(newItem);
        }
        if (pivotOption.col.length === 0 && colKey === '') {
          colKey = '-';
        }
        //INFO 데이터 세팅
        const newItem = rowMap[rowKey];
        newItem[colKey] = item.VALUE;
        itemMap[key] = item;

        //INFO 헤더 세팅
        if (!headerMap.hasOwnProperty(colKey)) {
          headerMap[colKey] = true;
          const colHeaders = colHeaderFunc(item);
          headers.push(createHeaderFunc(colHeaders, colKey, {Type: "Float", Format: "#,##0.#####", CanEmpty: 1}));
        }
      });
      return {
        headers: headers,
        data: items,
        rowMap: rowMap,
        leftCols: leftCols
      };
    },

    /**
     * 데이터 필터 처리
     * @param arrayList
     * @param strTarget
     * @param arrayFilterStr
     * @returns {*}
     */
    getDataFilter(arrayList, strTarget, arrayFilterStr) {
      return arrayList.filter(function (objects) {
        let result = false;
        arrayFilterStr.forEach((item) => {
          if (item === objects[strTarget]) {
            result = true;
          }
        });
        return result;
      });
    },

    /**
     * 데이터 필터 처리 (해당 조건을 제외한 데이터 처리)
     * @param arrayList
     * @param strTarget
     * @param arrayFilterStr
     * @returns {*}
     */
    getDataRemoveFilter(arrayList, strTarget, arrayFilterStr) {
      return arrayList.filter(function (objects) {
        let result = false;
        arrayFilterStr.forEach((item) => {
          if (item !== objects[strTarget]) {
            result = true;
          }
        });
        return result;
      });
    },

    /**
     * IBSheet 객체 제거
     */
    disposeIbSheet() {
      // 시트 객체가 존재할 경우 삭제
      if (IBSheet.hasSheet(this.stblSheetId)) {
        window[this.stblSheetId].dispose();
      }
      // 시트 객체가 존재할 경우 삭제
      if (IBSheet.hasSheet(this.stblSheetId)) {
        window["pivotSheet_" + this.stblSheetId].dispose();
      }
    },
    /**
     * 차트 제거
     */
    disposeIbchart() {
      if (document.querySelector("#"+this.stblChartId)) {
        document.querySelector("#"+this.stblChartId).replaceChildren();
      }
    },

    /**
     * 조회설정 박스 열기
     * @param type 조회 설정 or 피벗
     */
    filterBox(type) {
      if (this.$refs['filterSlide' + this.itemIdx].classList.contains('open')) {
        if (this.filterTab === type) {
          this.$refs['filterSlide' + this.itemIdx].classList.remove('open')
        }
      } else {
        this.$refs.pivotPopup.dataSet();
        this.$refs['filterSlide' + this.itemIdx].classList.add('open');
      }
      this.filterTab = type;
    },

    /**
     * 조회설정 박스 닫기
     */
    filterBoxClose() {
      this.$refs['filterSlide' + this.itemIdx].classList.remove('open')
    },

    /**
     * 옵션 리스트 드롭다운
     * @param evt
     */
    filterListToggle(evt) {
      const target = evt.target
      $(target).parents('.filter-list-box').toggleClass('off')
      $(target).toggleClass('close')
    },
    /**
     * 필터 검색
     */
    filterSearch(){
      this.initFilterSearchResult();
      if (this.filterSearchText.trim().length > 0) {
        this.filterSearchList = Array.from(document.querySelectorAll('.filter-list-Label')).filter(label => label.innerText.indexOf(this.filterSearchText) > -1)
      }
      this.filterSearchTotalCount = this.filterSearchList.length;
      this.filterSearchMove();
    },
    /**
     * 필터 정보 초기화 처리
     */
    initFilterSearchResult() {
      //this.filterSearchList = Array.from(document.querySelectorAll('.filter-list-Label'))
      this.filterSearchList.forEach(item => {
        item.innerHTML = item.innerText;
      });
      this.filterSearchList = [];
      this.filterSearchTotalCount = 0;
      this.filterSearchCurrent = 1;
    },
    /**
     * 필터 검색 이동
     */
    filterSearchMove() {
      this.filterSearchList.forEach((item, idx) => {
        if (this.filterSearchCurrent === idx + 1){
          // 검색 -> 현재 선택
          item.innerHTML = item.innerText.replaceAll(this.filterSearchText, '<em class="on-search-selected">' + this.filterSearchText + '</em>');
          // 스크롤 이동
          const parentEl = item.closest('.check-list-box');
          const togleEl = item.closest('.filter-list-box').querySelector('.filterListToggle');
          // 해당 필터 항목이 숨겨져 있을경우 처리
          if (togleEl.classList.contains('close')) {
            togleEl.classList.remove('close');
            togleEl.closest('.filter-list-box').classList.remove('off');
          }
          // 해당위치로
          parentEl.scrollTo(0, item.offsetTop - parentEl.offsetTop - 10);
        } else {
          // 검색 -> 미선택
          item.innerHTML = item.innerText.replaceAll(this.filterSearchText, '<em class="on-search">' + this.filterSearchText + '</em>');
        }
      })
    },
    /**
     * 필터 버튼 이벤트 처리
     * @param type 위로, 아래로, 삭제
     */
    moveSearchIndex(type) {
      if (type === 'delete') {
        this.filterSearchText = '';
        this.initFilterSearchResult();
      } else if (type === 'up') {
        if (this.filterSearchCurrent > 1) {
          this.filterSearchCurrent --;
        } else {
          this.filterSearchCurrent = this.filterSearchTotalCount;
        }
        this.filterSearchMove();
      } else if (type === 'down') {
        if (this.filterSearchCurrent !== this.filterSearchTotalCount) {
          this.filterSearchCurrent ++;
        } else {
          this.filterSearchCurrent = 1;
        }
        this.filterSearchMove();
      }
    },

    /**
     * 탭 패널 선택
     * @param tab
     * @param evt
     */
    selectTabPannel(tab, evt) {
      this.filterTab = tab;
      if (tab === 'pivot') {
        this.$refs.pivotPopup.dataSet();
      }
      $(evt.target).removeClass('tab2').addClass('tab1').parent().siblings().find('>a').removeClass('tab1').addClass('tab2')
    },

    /**
     * 필터 적용
     */
    filterApply() {
      // 원본 데이터에서 필터 데이터로 변환
      this.arrayDataFilter = this.arrayData // 초기데이터

      // 년도 필터 처리
      if (this.arrayYearItemFilterData && !this.$refs.checkAllYear.checked) { // 전체 선택 일경우 제외
        let result = [];
        this.arrayYearItemFilterData.forEach((item) => {
          if (item.checked) {
            result.push({
              key: item.filterKey,
              value: item.itemName,
            });
          }
        });
        if (result.length === 0) {
          this.$set(this.$refs.checkAllYear, 'checked', true);
          this.$refs.yearTreeChecker.forEach(checker => {
            checker.updateCheckAll(true);
          })
        } else {
          const arrayKeys = [...new Set(result.map(item => item.key))]
          arrayKeys.forEach(key => {
            let arrayFilterStr = result.filter(item => item.key === key).map(item => item.value)
            this.arrayDataFilter = this.getDataFilter(this.arrayDataFilter, key, arrayFilterStr)
          })
        }
      }

      // 항목 데이터 필터 처리
      if (this.arrayColItemFilterData && !this.$refs.checkAllCol.checked) { // 전체 선택 일경우 제외
        let result = []
        result.push(...this.extraFilter(this.arrayColItemFilterData, this.arrayColItemTitleData))
        // 전체 선택이 false 인데 체크된 데이터가 없을 경우 전체 선택을 체크해주고 필터는 수행하지 않음
        if (result.length === 0) {
          this.$set(this.$refs.checkAllCol, 'checked', true);
          this.$refs.colTreeChecker.forEach(checker => {
            checker.updateCheckAll(true);
          })
        } else {
          let tempArrayFilteredData = [];
          result.forEach(filterItem => {
            let tempArrayData = this.arrayDataFilter // 필터된 데이터
            const arrKey = Object.keys(filterItem)
            arrKey.forEach(key => {
              tempArrayData = tempArrayData.filter(item => item[key] === filterItem[key])
            })
            tempArrayFilteredData.push(...tempArrayData)
          })
          this.arrayDataFilter = tempArrayFilteredData;
        }
      }
      // 통계분류 데이터 필터처리
      if (this.arrayRowItemFilterData && !this.$refs.checkAllRow.checked) { // 전체 선택 일경우 제외
        //result.push(...this.extraFilter(this.arrayRowItemFilterData, this.arrayRowItemTitleData));
        let result = []
        result.push(...this.extraFilter(this.arrayRowItemFilterData, this.arrayRowItemTitleData));
        // 전체 선택이 false 인데 체크된 데이터가 없을 경우 전체 선택을 체크해주고 필터는 수행하지 않음
        if (result.length === 0) {
          //this.$refs.checkAllRow.checked = true
          this.$set(this.$refs.checkAllRow, 'checked', true);
          this.$refs.rowTreeChecker.forEach(checker => {
            checker.updateCheckAll(true);
          })
        } else {
          let tempArrayFilteredData = [];
          result.forEach(filterItem => {
            let tempArrayData = this.arrayDataFilter // 필터된 데이터
            const arrKey = Object.keys(filterItem)
            arrKey.forEach(key => {
              tempArrayData = tempArrayData.filter(item => item[key] === filterItem[key])
            })
            tempArrayFilteredData.push(...tempArrayData)
          })
          this.arrayDataFilter = tempArrayFilteredData;
        }
      }
      // 시트 초기화
      this.initSheet(this.pivotOption, this.arrayDataFilter);
      // 필터창 닫기
      this.filterBoxClose()
    },
    /**
     * 필터 초기화 -> 전체 선택 처리
     */
    filterReset () {
      // 년도
      this.$set(this.$refs.checkAllYear, 'checked', true);
      this.$refs.yearTreeChecker.forEach(checker => {
        checker.updateCheckAll(true);
      })
      // 항목
      this.$set(this.$refs.checkAllCol, 'checked', true);
      this.$refs.colTreeChecker.forEach(checker => {
        checker.updateCheckAll(true);
      })
      // 분류
      this.$set(this.$refs.checkAllRow, 'checked', true);
      this.$refs.rowTreeChecker.forEach(checker => {
        checker.updateCheckAll(true);
      })

    },
    /**
     * 필터 데이터 항목 검사
     * @param data
     * @param titleData
     * @returns {*[]}
     */
    extraFilter(data, titleData) {
      const result = [];
      data.forEach((item) => {
        if (item.checked) { // 체크 되어있을경우
          if (item.child && Array.isArray(item.child) && item.child.length > 0) { // 자식객체가 있을경우
            if (this.isAllCheck(item.child)) {
              // 자식이 모두 체크되어있을경우
              result.push(this.pathFilterStr(item.itemKeyPath, titleData))
            } else {
              // 자식검사
              result.push(...this.extraFilter(item.child, titleData));
            }
          } else {
            // 자식객체가 없을경우
            result.push(this.pathFilterStr(item.itemKeyPath, titleData))
          }
        }
      });
      return result;
    },

    /**
     * 배열 정렬 처리
     * @param array 정렬처리할 배열
     * @param sortArray 정렬 조건 배열
     * @returns {*}
     */
    sortByFields (array, sortArray) {
      return array.slice().sort((a, b) => {
        for (let {field, direction}of sortArray) {
          const valueA = a[field];
          const valueB = b[field];
          const dir = direction === 'desc' ? -1 : 1;
          if (valueA === valueB) continue;

          if (typeof  valueA === 'string') {
            return valueA.localeCompare(valueB) * dir;
          }
          return (valueA - valueB) * dir;
        }
        return 0;
      })
    },
    /**
     * 필터 조건 문자열로 변환
     * @param keyStr
     * @param titleData
     * @returns {{}}
     */
    pathFilterStr(keyStr, titleData) {
      const arrTitle = titleData.map(keys => keys.levelTitle)
      const filter = keyStr.split(this.delimiterCha).splice(2)
      const result = {}
      filter.forEach((item, index) => {
        if (item !== '') {
          result[arrTitle[index]] = item
        }
      })
      return result;
    },
    /**
     * 전체 옵션 체크박스 선택/해제
     * @param treeChecker
     * @param event
     */
    filterAllCheck(treeChecker, event) {
      treeChecker.forEach(checker => {
        checker.updateCheckAll(event.target.checked);
      })
    },
    /**
     * 1레벨 체크박스가 모두 선택/해제 일 경우 전체선택 상태를 업데이트 처리
     * @param arrData
     * @param target
     * @param model
     */
    allCheckFromChild(arrData, target, model) {
      model.checked = this.isAllCheck(arrData);
      //this.$set(target, 'checked', this.isAllCheck(arrData));
    },
    /**
     * 전체 체크 상태여부 확인
     * @param arrData
     * @returns {boolean}
     */
    isAllCheck(arrData) {
      let result = true;
      arrData.forEach((item) => {
        if (item.checked === false) {
          result = false;
        }
        if (item.child && Array.isArray(item.child) && result) {
          if (!this.isAllCheck(item.child)) {
            result = false;
          }
        }
      });
      return result;
    },

    /**
     * 기본정보 팝업 실행
     * @param popId
     * @param evt
     * @returns {Promise<void>}
     */
    async infoPopup(popId, evt) {
      const param = {
        tblMgmNo: this.statId
      }
      const basicData = await api.selectBasicInfo(param)
      this.staticBasicData = basicData.data
      this.staticBasicData.copyUrl = window.location.href
      this.popupOpen(popId)

      // 웹접근성 레이어 팝업 키보드 초점
      this.popBtn = evt.target
      setTimeout(() => {
        popId.firstChild.focus()
      }, 300);
    },

    /**
     * 팝업 열기
     * @param popId
     */
    popupOpen(popId) {
      popId.classList.add('open')
    },

    /**
     * 팝업 닫기
     * @param popId
     */
    popupClose(popId) {
      popId.classList.remove('open')

      // 웹접근성 레이어 팝업 키보드 초점
      this.popBtn.focus()
    },

    /**
     * 차트 새창으로 열기
     */
    chartPopup() {
      window.openerVue = this;
      window.open('/portal/chart/ChartPopup', '_blank')
    },
    /**
     * 필터 차트 새창으로 열기
     */
    chartFilterPopup() {
      window.openerVue = this;
      window.open('/portal/chart/chartFilterPopup', '_blank')
    },

    /**
     * OPEN API 메뉴얼 새창으로 열기
     */
    openApiDocPopup() {
      window.open('/portal/notice/StatsOpenApi', '_blank', 'noopener, noreferrer')
    },

    /**
     * 링크 주소(URL) 생성 팝업 열기
     * @param evt
     */
    onClickMyStatsPopup(evt) {
      this.$refs.statPopup.open({
        pivotOption: {
          col: this.pivotOption.col,
          row: this.pivotOption.row
        },
        filters: this.arrayDataFilter,
        filterData: {
          year: this.arrayYearItemFilterData,
          col: this.arrayColItemFilterData,
          row: this.arrayRowItemFilterData
        }
      });

      // 웹접근성 레이어 팝업 키보드 초점
      this.popBtn = evt.target
      setTimeout(() => {
        const popup = this.$refs.statPopup.$el
        popup.firstChild.focus();
      }, 300);
    },

    /**
     * 링크 주소(URL) 접근 시 처리
     * @param parametersId
     */
    setMyStatsParameters(parametersId) {
      getStatsParameters(parametersId).then(parameters => {
        if (parameters.hasOwnProperty('pivotOption')) {
          this.pivotOption.col = parameters.pivotOption.col;
          this.pivotOption.row = parameters.pivotOption.row;
        }

        if (parameters.hasOwnProperty('filters'))
          this.arrayDataFilter = parameters.filters;

        if (parameters.hasOwnProperty('filterData')) {
          this.arrayYearItemFilterData = parameters.filterData.year;
          this.arrayColItemFilterData = parameters.filterData.col;
          this.arrayRowItemFilterData = parameters.filterData.row;
        }

        this.initSheet(this.pivotOption, this.arrayDataFilter);
      });
    },

    /**
     * 행열전환
     */
    pivotReverse() {
      let row = this.pivotOption.row
      this.pivotOption.row = this.pivotOption.col
      this.pivotOption.col = row
      this.initSheet(this.pivotOption, this.arrayDataFilter);
    },
    /**
     * 피벗다이얼로그 에서 피벗 실행
      * @param pivotOption
     */
    pivotApply(pivotOption) {
      this.initSheet(pivotOption, this.arrayDataFilter);
    },
    /**
     * 화면 복사
     */
    copySheetData () {
      const sheetData = this.stblSheet.extractDataText({excludeHideData:1 })
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(sheetData).then(() => {
          alert("클립보드에 저장되었습니다.");
        }).catch(err => {
          console.error("copySheetData err", err);
        });
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = sheetData;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          document.execCommand('copy');
          alert("클립보드에 저장되었습니다.");
        } catch (err) {
          console.error("copySheetData fallback err", err);
        }
        document.body.removeChild(textarea);
      }
    },
    /**
     * 통계표 URL 클립보드 복사
     */
    copySheetUrl() {
      const url = this.staticBasicData.copyUrl;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
          alert("클립보드에 저장되었습니다.");
        }).catch(err => {
          console.error("copySheetData err", err);
        });
      } else {
        // HTTP 환경(navigator.clipboard 미지원) 폴백
        const textarea = document.createElement('textarea');
        textarea.value = url;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          document.execCommand('copy');
          alert("클립보드에 저장되었습니다.");
        } catch (err) {
          console.error("copySheetData fallback err", err);
        }
        document.body.removeChild(textarea);
      }
    },
    /**
     * 시트 파일 다운로드
     * @param type
     */
    exportSheetData (type) {
      let data = []
      data.push(new Date().getFullYear())
      data.push(new Date().getMonth() + 1 < 10? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1);
      data.push(new Date().getDate())
      data.push(this.statId)
      this.stblSheet.exportData({fileName: data.join('_')+type});

      // 다운로드 이력저장
      const paramData = {
        statsType: '01',  // 승인통계
        tblMgmNo: this.statId, // 통계표 id
        downType : ''
      }
      if (type === '.xlsx') {
        paramData.downType = '01'
      } else if (type === '.csv') {
        paramData.downType = '02'
      } else if (type === '.txt') {
        paramData.downType = '03'
      }
      api.saveDownloadHistory(paramData)
    },
    /**
     * 템플릿 -> 시트 컬럼 CSS 설정
     * @param targetClass
     */
    chartTempColor(targetClass) {
      this.stblSheetDiv.querySelector('.IBMainTable').classList.remove(this.ColBgColor)
      this.stblSheetDiv.querySelector('.IBMainTable').classList.add(targetClass)
      this.ColBgColor = targetClass
    },
    /**
     * 템플릿 -> 시트 컬럼 백그라운드 컬러 변경
     * @param evt
     */
    tempBgColor(evt) {
      const targetClass = evt.target.getAttribute('data-temp-bg')
      this.tempTextSize(targetClass);
    },
    /**
     * 템플릿 -> 시트 텍스트 사이즈 변경
     * @param targetClass
     */
    tempTextSize(targetClass) {
      const colLengh = this.stblSheet.getCols().length;
      const colWidth = [];

      let colSize;
      if (targetClass === 'temp-bg-blue') { // 블루 템플릿
        colSize = '7'; // 컬럼 가로 사이즈
        this.stblSheet.setSize('Normal'); // 셀 높이 사이즈
      } else if (targetClass === 'temp-bg-orange') { // 오렌지 템플릿
        colSize = '6'; // 컬럼 가로 사이즈
        this.stblSheet.setSize('Low'); // 셀 높이 사이즈
      } else { // 그린 템플릿
        colSize = '5'; // 컬럼 가로 사이즈
        this.stblSheet.setSize('Small'); // 셀 높이 사이즈
      }
      this.chartTempColor(targetClass);

      /*for(let i = 0; i <= colLengh; i++) {
        colWidth.push(colSize);
      }
      this.stblSheet.fitColWidth(colWidth);*/
      this.stblSheet.setAllFitSize()
    },
    /**
     * 차트 이미지 저장
     */
    saveChartToImg() {
      let saveDivSelector = this.stblChartId;

      if ($("#"+saveDivSelector).length === 0) {
        console.warn("생성된 차트가 없습니다.");
        return;
      }
      const saveImg = (uri, filename) => {
        let link = document.createElement('a');
        document.body.appendChild(link);
        link.href = uri;
        link.download = filename;
        link.click();
        document.body.removeChild(link);
      };
      html2canvas(document.querySelector("#"+saveDivSelector)).then(canvas => {
        saveImg(canvas.toDataURL(), this.stblTitle + '.png');
      });
    },
    /**
     * 차트 선택 색상 변경 처리
     * @param evtParam
     */
    setCrossColor(evtParam) {
      if (this.beforeCrossColorInfo.row) {
        evtParam.sheet.setAttribute(this.beforeCrossColorInfo.row, null, "Color", "#FFFFFF", 1);
      }
      evtParam.sheet.setAttribute(evtParam.row, null, "Color", "#e3eef0", 1);
      this.beforeCrossColorInfo.row = evtParam.row;
      if (this.beforeCrossColorInfo.column) {
        evtParam.sheet.setAttribute(null, this.beforeCrossColorInfo.column, "Color", "#FFFFFF", 1);
      }
      evtParam.sheet.setAttribute(null, evtParam.col, "Color", "#e3eef0", 1);
      this.beforeCrossColorInfo.column = evtParam.col;
    },

  }
}
</script>

<style scoped>
.stat-title {
  display: flex;
  justify-content: space-between;
}

.img-save {
  height: 30px;
  border-radius: 3px;
  border: 1px solid #2a2c2f;
  background: #fff;
  line-height: 30px;
  font-weight: 500;
  font-size: 14px;
  color: #2a2c2f;
  width: 120px;
}

</style>
